import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { FrequentlyOrderProduct } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type FrequentlyOrderProductListResponse = FrequentlyOrderProduct[];

export interface FrequentlyOrderDataSource {
  // Query
  getFrequentlyOrderProducts(): Promise<FrequentlyOrderProductListResponse>;
}

export class FrequentlyOrderDataSourceImpl
  implements FrequentlyOrderDataSource
{
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getFrequentlyOrderProducts() {
    return this.client.request<FrequentlyOrderProductListResponse>({
      url: '/api/market-place/v1/frequently-order/products',
      method: 'get',
    });
  }
}

export const frequentlyOrderDataSource = new FrequentlyOrderDataSourceImpl();
